/* 创建活动card
 * basePath:/card/create
 */
import { watch } from 'vue'
import {
  ams_admin_card_create_post,
  ams_admin_card_get_id_get,
  ams_admin_card_activity_list_post,
  ams_admin_card_modify_post,
  ams_admin_card_list_post,
  ams_admin_card_delete_id_get,
  ams_admin_card_sequence_id1_id2_get
} from 'server/modules/3109'
import { message } from 'ant-design-vue'

const params = {}

export const createCardPost = async function() {
  const { success, data, retInfo } = await ams_admin_card_create_post({
    ...params
  })
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}
export const getCardById = async function() {
  const { success, data, retInfo } = await ams_admin_card_get_id_get({
    ...params
  })
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}
// 获取活动规则
export const postCardActivityList = async function() {
  const { success, data, retInfo } = await ams_admin_card_activity_list_post({
    ...params
  })
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 处理活动列表
export const useCardList = function() {
  const { state } = arguments[0]
  const getCardList = async () => {
    const { searchParams } = state
    if (
      searchParams.brandId === null ||
      searchParams.channelId === null ||
      searchParams.siteId === null
    ) {
      return
    }

    const { success, data, retInfo } = await ams_admin_card_list_post(
      state.searchParams
    )
    if (success) {
      state.dataList = data
    } else {
      message.error({ title: retInfo })
    }
  }
  const changeHistoryURL = () => {
    const { channelId, siteId, brandId, terminalId } = state.searchParams
    state.router.replace({
      path: '/ActivityCard',
      query: {
        brandId: +brandId,
        channelId: +channelId,
        siteId: +siteId,
        terminalId: +terminalId
      }
    })
  }
  state.getCardList = getCardList
  watch(
    () => state.searchParams,
    () => {
      changeHistoryURL()
      getCardList()
    },
    {
      deep: true
    }
  )
  return {
    getCardList
  }
}
// 删除卡片活动
export const deleteCardById = async function() {
  const { state } = arguments[0]
  const { success, retInfo } = await ams_admin_card_delete_id_get(arguments[1])
  if (success) {
    state.getCardList()
    message.success('删除成功')
  } else {
    message.error(retInfo || '删除失败')
  }
}
export const modifyCardPost = async function() {
  const { success, data, retInfo } = await ams_admin_card_modify_post({
    ...params
  })
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}
export const sequenceCardList = async function() {
  const { state } = arguments[0]
  const { success, retInfo } = await ams_admin_card_sequence_id1_id2_get(
    arguments[1]
  )
  if (success) {
    state.getCardList()
  } else {
    message.error(retInfo)
  }
}
